import gql from 'graphql-tag';

export const Organizations = gql`
  query Organizations {
    organizations {
      id
      name
      logo
      timezone
      locale
      mfaPolicy
      createdAt
      updatedAt
    }
  }
`;
